<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="card-title mb-4 float-sm-left">
            <template v-if="filter_pesananChart == 'years'">
              <date-picker v-model="date" :editable="false" :clearable="false" @input="filterSelect" type="year" format="YYYY" placeholder="Pilih  Tahun"></date-picker>
            </template>
            <template v-else-if="filter_pesananChart == 'month'">
              <date-picker v-model="date" :editable="false" :clearable="false" @input="filterSelect" type="month" format="MMMM" placeholder="Pilih  Bulan"></date-picker>
            </template>
            <template v-else-if="filter_pesananChart == 'week'">
              <date-picker v-model="date" :editable="false" :clearable="false"  @input="filterSelect" type="week" format="YY-MM-DD" placeholder="Pilih  Bulan"></date-picker>
            </template>
          </div>
          <div class="float-sm-right">
            <ul class="nav nav-pills">
              <li class="nav-item">
                <a :class="(filter_pesananChart == 'week' ? 'active ' : '')+'nav-link'" @click="filterBy('week')" href="javascript:;">Week</a>
              </li>
              <li class="nav-item">
                <a :class="(filter_pesananChart == 'month' ? 'active ' : '')+'nav-link'" @click="filterBy('month')" href="javascript:;">Month</a>
              </li>
              <li class="nav-item">
                <a :class="(filter_pesananChart == 'years' ? 'active ' : '')+'nav-link'" @click="filterBy('years')" href="javascript:;">Year</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <loading :active.sync="isLoading" :is-full-page="false" :height="45" :width="45" color="#398BD7"></loading>
      <Highcharts :options="pesananChart"></Highcharts>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_module: "dashboards",
      pesananChart: {},
      CategoryChart: {},
      gaugeChart: {},
      filter_pesananChart: 'month',
      date : new Date(),
      isLoading :true,
    };
  },
  mounted() {
    this.showChart();
  },
  methods: {
    filterSelect(){
      this.showChart()
    },
    filterBy(display_date=null){
      this.date = new Date();
      this.filter_pesananChart = display_date;
      this.showChart()
    },
    showChart: function () {
      this.isLoading = true
      let params = {};

      params['display_date'] = this.filter_pesananChart
      params['date'] = this.$moment(this.date).format('YYYY-MM-DD')

      this.axios
        .post("/" + this.table_module + "/total-transaksi-servis", params)
        .then((response) => {
          this.isLoading = false;
          var series = response.data.data.data;
          var categories = response.data.data.categories;

          this.$nextTick(() => {
            this.pesananChart = {
              chart: {
                type: "column",
              },
              title: {
                text: "Total Transaksi Servis",
              },
              subtitle: {
                text: null,
              },
              xAxis: {
                categories: categories,
                crosshair: true,
              },
              yAxis: {
                min: 0,
                title: {
                  text: "Rupiah (IDR)",
                },
              },
              tooltip: {
                headerFormat:
                  '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat:
                  '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                  '<td style="padding:0"><b>{point.y:,.0f}</b></td></tr>',
                footerFormat: "</table>",
                shared: true,
                useHTML: true,
              },
              plotOptions: {
                column: {
                  pointPadding: 0.2,
                  borderWidth: 0,
                },
              },
              credits: {
                enabled: false,
              },
              series: series,
            };
          });
        });
    },
  },
}
</script>